import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import Contact from "@/views/Contact";
import Pricing from "@/views/Pricing";
import About from "@/views/About";
import Faq from "@/views/Faq";
import Services from "@/views/Services";
import Services2 from "@/views/Services2";
import InvestorCharter from "@/views/InvestorCharter";
import InvestorComplaints from "@/views/InvestorComplaints";
import ComplianceAudit from "@/views/ComplianceAudit";
import ConflictOfInterest from "@/views/ConflictOfInterest";
import AntiMoneyLaunderingPolicy from "@/views/AntiMoneyLaunderingPolicy";
import CodeOfConduct from "@/views/CodeOfConduct";
import Grievance from "@/views/Grievance";
import Disclaimer from "@/views/Disclaimer";
import Landing from "@/views/Landing";
import NewLanding from "@/views/NewLanding";
import StarterLanding from "@/views/StarterLanding";
import Newsletter from "@/views/Newsletter";
import Welcome from "@/views/Welcome";
import Admin from "@/views/Admin";
import LoginSignup from "@/views/LoginSignup";
import ForgotPassword from "@/views/ForgotPassword";
import ResetPassword from "@/views/ResetPassword";
import MandatoryDisclosure from "@/views/MandatoryDisclosure";
import TermsAndConditions from "@/views/TermsAndConditions";
import ValidUpi from "@/views/ValidUpi";
import MyAccount from "@/views/MyAccount";
import Sitemap from "@/views/Sitemap";
import AddNewStock from "@/components/admin/AddNewStock";
import StockList from "@/components/admin/StockList";
import AddNewUser from "@/components/admin/AddNewUser";
import UserList from "@/components/admin/UserList";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: { title: "Grow With Stocks - SEBI Registered Research Analyst" }
    },
    {
      path: "/about",
      name: "About",
      component: About,
      meta: { title: "About Us | Grow With Stocks" }
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
      meta: { title: "Pricing Plans | Grow With Stocks" }
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq,
      meta: { title: "Frequently Asked Questions | Grow With Stocks" }
    },
    {
      path: "/services",
      name: "Services",
      component: Services,
      meta: { title: "Services | Grow With Stocks" }
    },
    {
      path: "/investor-charter",
      name: "InvestorCharter",
      component: InvestorCharter,
      meta: { title: "Investor Charter | Grow With Stocks" }
    },
    {
      path: "/investor-complaints",
      name: "InvestorComplaints",
      component: InvestorComplaints,
      meta: { title: "Investor Complaints | Grow With Stocks" }
    },
    {
      path: "/conflicts-of-interest",
      name: "ConflictOfInterest",
      component: ConflictOfInterest,
      meta: { title: "Conflict of Interest | Grow With Stocks" }
    },
    {
      path: "/anti-money-laundering-policy",
      name: "AntiMoneyLaunderingPolicy",
      component: AntiMoneyLaunderingPolicy,
      meta: { title: "Anti-Money Laundering Policy | Grow With Stocks" }
    },
    {
      path: "/code-of-conduct",
      name: "CodeOfConduct",
      component: CodeOfConduct,
      meta: { title: "Code of Conduct | Grow With Stocks" }
    },
    {
      path: "/compliance-audit",
      name: "ComplianceAudit",
      component: ComplianceAudit,
      meta: { title: "Compliance Audit | Grow With Stocks" }
    },
    {
      path: "/grievance",
      name: "Grievance",
      component: Grievance,
      meta: { title: "Grievance Redressal | Grow With Stocks" }
    },
    {
      path: "/our-services",
      name: "OurServices",
      component: Services2,
      meta: { title: "Our Services | Grow With Stocks" }
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: { title: "Contact Us | Grow With Stocks" }
    },
    {
      path: "/login",
      name: "Login",
      component: LoginSignup,
      meta: { title: "Login | Grow With Stocks" }
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: { title: "Forgot Password | Grow With Stocks" }
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPassword,
      meta: { title: "Reset Password | Grow With Stocks" }
    },
    {
      path: "/disclaimer",
      name: "Disclaimer",
      component: Disclaimer,
      meta: { title: "Disclaimer | Grow With Stocks" }
    },
    {
      path: "/signup",
      name: "Signup",
      component: LoginSignup,
      meta: { title: "Sign Up | Grow With Stocks" }
    },
    {
      path: "/mandatory-disclosure",
      name: "MandatoryDisclosure",
      component: MandatoryDisclosure,
      meta: { title: "Mandatory Disclosure | Grow With Stocks" }
    },
    {
      path: "/terms-and-conditions",
      name: "TermsAndConditions",
      component: TermsAndConditions,
      meta: { title: "Terms and Conditions | Grow With Stocks" }
    },
    {
      path: "/valid-upi",
      name: "ValidUpi",
      component: ValidUpi,
      meta: { title: "Valid UPI | Grow With Stocks" }
    },
    {
      path: "/sitemap",
      name: "Sitemap",
      component: Sitemap,
      meta: { title: "Sitemap | Grow With Stocks" }
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      meta: {
        auth: true,
        title: "Admin | Grow With Stocks"
      },
      children: [
        {
          path: "addnewstock",
          name: "AddNewStock",
          component: AddNewStock,
          meta: { title: "Add New Stock | Admin | Grow With Stocks" }
        },
        {
          path: "",
          name: "StockList",
          component: StockList,
          meta: { title: "Stock List | Admin | Grow With Stocks" }
        },
        {
          path: "addnewuser",
          name: "AddNewuser",
          component: AddNewUser,
          meta: { title: "Add New User | Admin | Grow With Stocks" }
        },
        {
          path: "userlist",
          name: "UserList",
          component: UserList,
          meta: { title: "User List | Admin | Grow With Stocks" }
        }
      ]
    },
    {
      path: "/myaccount",
      name: "MyAccount",
      component: MyAccount,
      meta: {
        auth: true,
        title: "My Account | Grow With Stocks"
      }
    },
    { path: "*", component: Home, meta: { title: "Grow With Stocks - SEBI Registered Research Analyst" } },
    {
      path: "/returns",
      name: "Landing",
      component: Landing,
      meta :{
        empty : true,
        title: "Returns | Grow With Stocks"
      }
    },
    {
      path: "/investor",
      name: "NewLanding",
      component: NewLanding,
      meta :{
        empty : true,
        title: "Investor | Grow With Stocks"
      }
    },
    {
      path: "/starter",
      name: "StarterLanding",
      component: StarterLanding,
      meta :{
        empty : true,
        title: "Starter Plan | Grow With Stocks"
      }
    },
    {
      path: "/newsletter",
      name: "Newsletter",
      component: Newsletter,
      meta :{
        empty : true,
        title: "Newsletter | Grow With Stocks"
      }
    },
    {
      path: "/welcome",
      name: "Welcome",
      component: Welcome,
      meta: { title: "Welcome | Grow With Stocks" }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { y: 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js